exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.progress {\n  position: relative;\n  height: 15px;\n  display: block;\n  width: 100%;\n  background-color: #f9c9cb;\n  border-radius: 2px;\n  margin: 0.5rem 0 1rem 0;\n  overflow: hidden;\n}\n\n.progress .determinate {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  background-color: #ee6e73;\n  transition: width .3s linear;\n}\n\n.progress .indeterminate {\n  background-color: #ee6e73;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/bernie/bernie.component.css
// module id = ../../../../../src/app/bernie/bernie.component.css
// module chunks = main